import React from "react";
import Underline from "../../widgets/Underline/Underline";
import Gallery from "../../components/Gallery/Gallery";
import "./EventShowcase.css";

const EventShowcase = ({ heading, date, organizer, content, images = [] }) => {
  return (
    <div className="event-container">
      {/* Heading */}
      {heading && (
        <div className="event-heading">
          <Underline heading={heading} />
        </div>
      )}

      {/* Organizer & Date */}
      {(organizer || date) && (
        <div className="event-details">
          {organizer && (
            <p>
              Organized by: {organizer}
            </p>
          )}
          {date && (
            <p>
              Date: {date}
            </p>
          )}
        </div>
      )}

      {/* Content */}
      {content && (
        <p className="event-content">
          {content.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {index < content.split('\n').length - 1 && <br />}
            </React.Fragment>
          ))}
        </p>
      )}

      {/* Gallery Section */}
      {images.length > 0 && (
        <div className="event-gallery-section">
          {/* <h3 className="event-gallery-heading">Photos:</h3> */}
          <Gallery images={images} />
        </div>
      )}
    </div>
  );
};

export default EventShowcase;
